export function formatPrice(
  cents: number | undefined | null,
  currency = "USD",
) {
  const amount = cents !== undefined && cents !== null ? cents / 100 : 0;
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
}
